import { TransferState, ɵgetDOM } from '@angular/platform-browser';
import { Injector, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser, LOCATION_INITIALIZED } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GlobalComponentService } from '@techmore/global';
import { GeneratorEnv } from './web-generator/generator-env-token';
import { environment } from 'src/environments/environment';
import { ServerConfigService } from './share/service/server-config.service';
import { BackStageTemplateService } from './share/service/back-stage-template.service';
import { translateBrowserLoaderFactory } from './share/service/translate-browser-loader.service';
import { EventReplayer } from 'preboot';
import { CSP_NONCE_KEY } from './share/tokens/csp-nonce.statekey';
import { LoggerService } from './share/service/logger.service';
import { backstageEditModeInitFn } from './backstage-edit-mode-init.fn';
import { switchMap } from 'rxjs/operators';
export function initializationFactory(injector, serverConfigService, loggerService, backStageTemplateService) {
    return () => new Promise((resolve) => {
        const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
        const platformId = injector.get(PLATFORM_ID);
        const isBrowser = isPlatformBrowser(platformId);
        if (!isBrowser) {
            loggerService.info(`initializationFactory`);
        }
        if (isBrowser) { // preboot 的設定
            const dom = ɵgetDOM();
            const styles = Array.prototype.slice.apply(dom.querySelectorAll(document, `style[ng-transition]`));
            styles.forEach(el => {
                // Remove ng-transition attribute to prevent Angular appInitializerFactory
                // to remove server styles before preboot complete
                el.removeAttribute('ng-transition');
            });
            document.addEventListener('PrebootComplete', () => {
                // After preboot complete, remove the server scripts
                setTimeout(() => styles.forEach(el => dom.remove(el)));
            });
            if (serverConfigService.isEditModeUrl) { // 'aHR0cCUzQSUyRiUyRmxvY2FsaG9zdCUzQTQzMDA='
                // 如果是編輯模式的 url，直接進 CSR 畫面
                const replayer = injector.get(EventReplayer);
                replayer.replayAll();
            }
        }
        backstageEditModeInitFn(serverConfigService, isBrowser, backStageTemplateService, locationInitialized, loggerService).pipe(switchMap(_ => serverConfigService.loadConfig$())).subscribe(_ => {
            resolve();
        });
    });
}
export function i18nLoaderFactory(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
const ɵ0 = translateBrowserLoaderFactory, ɵ1 = () => {
    return Object.assign(new GeneratorEnv(), {
        apiHost: environment.apiHost,
        allowBackStageDomain: environment.allowBackStageDomain,
        recaptchaKey: environment.recaptchaKey,
        commonToken: environment.commonToken,
        itriSearchApiHost: environment.itriSearchApiHost,
        itriAutoCompleteApiHost: environment.itriAutoCompleteApiHost,
        accessTokenKey: 'accessToken',
        refreshTokenKey: 'refreshToken',
        googleSiteVerification: environment.googleSiteVerification,
    });
}, ɵ2 = (platformId, tState, response) => {
    if (isPlatformBrowser(platformId)) {
        return tState.get(CSP_NONCE_KEY, '');
    }
    else {
        return response.locals.cspNonce;
    }
};
export class AppModule {
    constructor(injector, translate, platformId, memberCenterService, tokenService, globalComponentService, router) {
        this.injector = injector;
        this.translate = translate;
        this.platformId = platformId;
        if (isPlatformBrowser(this.platformId)) {
            // localStorage.removeItem('site_token');
            tokenService.registCustomLogout(() => {
                return new Promise((resolve, reject) => {
                    try {
                        const jwt = tokenService.getJWTpayload();
                        const expireDuration = Math.ceil((jwt.exp - jwt.iat) / 60);
                        memberCenterService.logout(false);
                        globalComponentService.openErrorAlert(`會員登入已閒置${expireDuration}分鐘，請您重新登入。`);
                        // globalComponentService.openSanckBar('會員已被登出，請重新登入', 'X', {duration: 5000, horizontalPosition: 'right'});
                        router.navigateByUrl('/zh-tw').then(_ => {
                            resolve(_);
                        }).catch(error => {
                            reject(error);
                        });
                    }
                    catch (error) {
                        reject(error);
                    }
                });
            });
        }
        // this.translate.addLangs(['zh-tw']);
        // this.translate.setDefaultLang('zh-tw');
    }
}
export { ɵ0, ɵ1, ɵ2 };
